module.exports = __webpack_public_path__ + "static/media/italy.02394e47.svg";